import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { toTitleCase } from '../../utils/format';

function initials(name = '') { return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase(); }

export default function StudentSidebar({ course, modules, currentModuleId }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  function navTo(path) { navigate(path); setOpen(false); }

  return (
    <>
      {/* Mobile top bar */}
      <div className="mob-bar">
        <div className="mob-logo">
          <div className="sb-mark"><svg viewBox="0 0 14 14" fill="none"><polygon points="7,1 13,13 1,13" fill="#0C0B09" /></svg></div>
          <div className="sb-brand">AI <span>Foundry</span></div>
        </div>
        <button className={`hamburger${open ? ' open' : ''}`} onClick={() => setOpen(o => !o)}>
          <span /><span /><span />
        </button>
      </div>

      {/* Sidebar overlay */}
      <div className={`sb-overlay${open ? ' open' : ''}`} onClick={() => setOpen(false)} />

    <aside className={`sb${open ? ' open' : ''}`}>
      <div className="sb-logo">
        <div className="sb-mark">
          <svg viewBox="0 0 14 14" fill="none">
            <polygon points="7,1 13,13 1,13" fill="#0C0B09" />
          </svg>
        </div>
        <div className="sb-brand">AI <span>Foundry</span></div>
        <button onClick={() => setOpen(false)} className="sb-close" style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#5A5650', cursor: 'pointer', fontSize: 18, padding: '2px 4px', display: 'none' }}>✕</button>
      </div>

      <div className="sb-sec">
        <div className="sb-lbl">Learning</div>
        <NavLink
          to="/student/dashboard"
          className={({ isActive }) => `sb-link${isActive ? ' on' : ''}`}
          onClick={() => setOpen(false)}
        >
          <span className="ic">⊞</span> My Courses
        </NavLink>

        {course && (
          <>
            <div className="sb-divider" />
            <div
              className={`sb-link${!currentModuleId ? ' on' : ''}`}
              style={{ fontWeight: 600, cursor: 'pointer' }}
              onClick={() => navTo(`/student/courses/${course.id}`)}
            >
              <span className="ic">{course.emoji}</span>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {toTitleCase(course.title)}
              </span>
            </div>

            {modules.map((m, i) => {
              const icon = m.is_completed ? '✓' : m.status === 'current' ? '▶' : '○';
              const isOn = String(m.id) === String(currentModuleId);
              return (
                <div
                  key={m.id}
                  className={`sb-mod-link${isOn ? ' on' : ''}${m.status === 'locked' ? ' locked' : ''}`}
                  onClick={() => navTo(`/student/courses/${course.id}/modules/${m.id}`)}
                  title={m.title}
                >
                  <span style={{ fontSize: 10, flexShrink: 0 }}>{icon}</span>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{toTitleCase(m.title)}</span>
                </div>
              );
            })}
          </>
        )}
      </div>

      <div className="sb-foot">
        <div className="av-stu">{user ? initials(user.full_name) : 'ST'}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="av-name">{toTitleCase(user?.full_name || 'Student')}</div>
          <div className="av-role">Student</div>
        </div>
        <button
          onClick={logout}
          title="Log out"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#5A5650', padding: '4px',
            borderRadius: 4, lineHeight: 1, flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'color 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F8F7F3'}
          onMouseLeave={e => e.currentTarget.style.color = '#5A5650'}
        >
          <svg viewBox="0 0 24 24" fill="none" width="17" height="17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            {/* Door rectangle */}
            <path d="M14 3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5" />
            {/* Arrow shaft */}
            <line x1="10" y1="12" x2="2" y2="12" />
            {/* Arrow head */}
            <polyline points="6 8 2 12 6 16" />
          </svg>
        </button>
      </div>
    </aside>
    </>
  );
}
